import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';
import { ValidationErrors } from '../../../../../modals/order-method/types';

export default {
  title: 'Locatie selecteren',
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Ter plaatse',
      [RoomServiceLocationType.TableService]: 'Ter plaatse',
      both: 'Ter plaatse',
    },
    [ORDER_METHODS.PICKUP]: 'Afhalen',
    [ORDER_METHODS.DELIVERY]: 'Bezorging',
  },
  text_inputs: {
    room_service_details: {
      placeholder: {
        [RoomServiceLocationType.RoomService]: 'Voer kamernummer in',
        [RoomServiceLocationType.TableService]: 'Voer tafelnummer in',
      },
    },
    address: {
      placeholder: 'Zoek je adres',
    },
    street_name: {
      placeholder: 'Straat',
    },
    street_number: {
      placeholder: 'Huisnummer',
    },
    city: {
      placeholder: 'Stad',
    },
    zip: {
      placeholder: 'Postcode',
    },
  },
  time_options: {
    asap: {
      title: 'Standaard',
      description: 'Klaar in {{time}} min',
    },
    scheduled: {
      title: 'Inplannen voor later',
    },
  },
  time_drop_down: {
    today: 'Vandaag',
  },

  room_service: {
    location: 'Locatie selecteren',
  },

  pickup: {
    address: 'Afhaaladres',
    when: 'Wanneer?',
  },

  delivery: {
    where: 'Waarheen?',
    when: 'Wanneer?',
    address: 'Jouw adres',
    delivery_area: 'Ons bezorggebied',
  },

  buttons: {
    view_menu: 'Menu bekijken',
    see_hours: 'Openingstijden',
    next: 'Volgende',
    change: 'Wijzigen',
    save: 'Opslaan',
  },

  labels: {
    when: 'Wanneer?',
    pickup: 'Online afhalen',
    delivery: 'Bezorging',
    pickup_time: 'afhaaltijd',
    delivery_time: 'bezorgtijd',
    discount: 'Alleen hier {{value}} online korting',
    pre_orders_enabled: 'Voorlopig kun je een geplande bestelling voor later plaatsen',
    change_location: '← Terug naar het menu voor een andere locatie',
    return: 'Terug',
  },

  items_dropped: {
    count_one: '{{count}} item verwijderd',
    count_other: '{{count}} items verwijderd',
    pickup_reason: '— niet beschikbaar voor afhalen.',
    delivery_reason: '— niet beschikbaar voor bezorging.',
  },

  error_messages: {
    [ValidationErrors.address_not_found]:
      'Sorry, we konden dat adres niet vinden. Probeer het opnieuw door eerst de straatnaam in te voeren in het zoekadresveld.',
    [ValidationErrors.address_not_serviceable]:
      'Jouw adres valt buiten onze bezorgzone. Wil je je adres wijzigen of overschakelen naar afhalen? 😊',
    [ValidationErrors.no_drivers_available]:
      'Sorry, we kunnen momenteel niet bezorgen. Wil je een afhaalbestelling plaatsen? 😊',

    room_service_unavailable: 'Het spijt ons dat we momenteel geen service ter plaatse aanbieden.',
    pickup_unavailable: 'Het spijt ons dat we momenteel geen afhalen aanbieden.',
    delivery_unavailable: 'Het spijt ons dat we momenteel geen bezorging aanbieden.',
    delivery_paused: 'Het spijt ons dat we momenteel geen bezorging aanbieden.',
    outside_pickup_times: 'We bieden momenteel geen afhalen aan. Onze afhaaltijden:',
    outside_delivery_times: 'We bieden momenteel geen bezorging aan. Onze bezorgtijden:',
    orders_paused_inactivity:
      'Door overweldigende drukte kunnen we momenteel geen online bestellingen accepteren. Bestel in de winkel of probeer het over 30 minuten opnieuw.',
    orders_paused_manual_end_of_day: 'Sorry, we zijn voor de rest van de dag gesloten.',
    orders_paused_manual_until_time:
      'Door overweldigende drukte kunnen we momenteel geen online bestellingen accepteren. Bestel in de winkel of probeer het opnieuw vanaf {{pausedUntil}}',
    company_closed: 'Helaas zijn we momenteel niet open.',
    pickup_closed:
      'We accepteren afhaalbestellingen tot {{time}} omdat onze bereidingstijd {{preparationTime}} minuten is.',
    delivery_closed:
      'We accepteren bezorgbestellingen tot {{time}} omdat onze bezorgtijd {{preparationTime}} minuten is.',
    live_orders_off: 'Het spijt ons, we kunnen momenteel geen online bestellingen accepteren. Bedankt voor je begrip.',
    orders_unavailable:
      '{{type}} is momenteel niet beschikbaar. De eerstvolgende mogelijke {{typeTime}} is {{day}} {{time}}.',
  },

  no_couriers: {
    with_code:
      'Het spijt ons, we hebben momenteel geen beschikbare bezorgers. Probeer het later opnieuw, of bestel voor afhalen en gebruik promotiecode <PromoCode>{{code}}</PromoCode> bij het afrekenen.',
    without_code:
      'Het spijt ons, we hebben momenteel geen beschikbare bezorgers. Probeer het later opnieuw, of bestel voor afhalen.',
    copied: 'Promotiecode gekopieerd',
  },
};
